import {
  FormLabel,
  Grid,
  TextField,
} from "@mui/material";

export const ViewAndEditEntity = ({
  handleInputChange,
  row,
  viewMode,
  validationStatus

}) => {
  //inline style
  const InlineStyle = {
    ChaserIndicator: {
      width: "230px",
      height: "32",
      padding: "0px",
    }
  };
  return (
    <form>
      <Grid container justifyContent={"space-between"} sx={{ width: "80%" }}>
        <Grid
          item
          xs={5}
          display={"flex"}
          flexDirection={"column"}
          gap={"5px"}
          mt={"20px"}
        >
          <FormLabel>Green to Yellow Duration</FormLabel>
          <TextField
            value={row.green_to_yellow}
            onChange={(e) => handleInputChange("green_to_yellow", e.target.value)}
            sx={InlineStyle.ChaserIndicator}
            size="small"
            placeholder=""
            disabled={viewMode}
          />
          <br />
          {validationStatus?.green_to_yellow && (
            <span style={{ color: "red" }}>
              {validationStatus?.green_to_yellow}
            </span>
          )}
        </Grid>
        <Grid
          item
          xs={5}
          display={"flex"}
          flexDirection={"column"}
          gap={"5px"}
          mt={"20px"}
        >
          <FormLabel>Yellow to Red Duration</FormLabel>
          <TextField
            value={row.yellow_to_red}
            onChange={(e) => handleInputChange("yellow_to_red", e.target.value)}
            sx={InlineStyle.ChaserIndicator}
            size="small"
            placeholder=""
            disabled={viewMode}
          />
          <br />
          {validationStatus?.yellow_to_red && (
            <span style={{ color: "red" }}>
              {validationStatus?.yellow_to_red}
            </span>
          )}
        </Grid>
      </Grid>
    </form>
  );
};
